{
  "title": "Costs",
  "intro": "What the project costs this month so far and by the end of it, by kind of resource, by day and by month.",
  "orgIntro": "Costs of every project of the organisation: this month so far, the forecast to its end, by kind of resource and by day.",
  "estimate": "This is our estimate, not an invoice: amounts exclude VAT and are counted for every started hour from the provider's price list, never above a resource's monthly price. Hetzner's invoice may differ slightly.",
  "meteredAt": "Last counted: {{time}}",
  "notMetered": "Not counted yet: the first amounts appear within a few minutes.",
  "month": "Month",
  "export": "Download CSV",
  "monthToDate": "Month to date",
  "monthTotal": "Whole month",
  "forecast": "Forecast for the month",
  "forecastHint": "Month to date plus everything in the project now until the month ends — never above each resource's monthly price. Traffic beyond the included amount is not forecast.",
  "lastMonth": "Last month",
  "projects": "Projects",
  "project": "Project",
  "noProjects": "No projects yet",
  "noProjectsLead": "Connect a Hetzner project and its costs are counted every hour.",
  "byKind": "By kind of resource",
  "byDay": "By day",
  "byMonth": "By month",
  "dayAmount": "Per day",
  "monthAmount": "Per month",
  "chartEmpty": "No costs in this period.",
  "top": "Most expensive",
  "resources": "Everything billed this month",
  "resource": "Resource",
  "kind": "Kind",
  "amount": "Amount excl. VAT",
  "deleted": "deleted",
  "empty": "No costs this month.",
  "emptyLead": "As soon as the project has billed resources — servers, addresses, volumes, snapshots — their costs are counted every hour.",
  "open": "Open costs",
  "kinds": {
    "server": "Servers",
    "backup": "Backups",
    "traffic": "Traffic beyond the included amount",
    "public_ip": "Public IPv4",
    "floating_ip": "Floating IPs",
    "volume": "Volumes",
    "snapshot": "Snapshots",
    "load_balancer": "Load balancers"
  },
  "appliance": "Appliance: {{name}}"
}
